import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";

/**
 * Get classrooms'information about an particular user.
 *
 * @param {(string)} teacherId Id of an particular student.
 * @returns {{data: Object, error: Error, loading: boolean}} Info about the query state.
 */
const useTeacherGet = (teacherId) => {
  const requestUrl = `${MONOLITH_ORIGIN}/api/v2/teacher/${teacherId}/`;
  return useRestQuery(requestUrl, { skip: !teacherId });
};

export default useTeacherGet;
